import { appShellStyles } from '../shared/components/AppShell.js'
import { subscribeAuthSession } from '../workspace-project/functions/auth.js'
import { loadPrivateData, onWorkspaceChange } from '../workspace-project/functions/loadPrivateData.js'

// Shell DOMQL — AppHeader + smbls-default content + TranslationWatcher.
//
// AppHeader: persistent top header. Hidden on auth routes via `hide:`.
// content: smbls router renders the matched page here automatically —
//   no explicit Slot element needed. The default router places content
//   as row 2 (1fr) in the AppShell grid.
// TranslationWatcher: hidden i18n subscription (position:fixed, no grid row).
//
// AppShell grid (from appShellStyles):
//   gridTemplateRows: 'auto 1fr'
//   AppHeader → row 1 (auto). smbls content → row 2 (1fr, fills viewport).
//   When AppHeader is hidden (display:none on auth routes) it leaves the
//   grid — content expands to fill the full viewport automatically.
const AUTH_PATHS = /^\/(login|signin|signup|signup-confirmation|reset-password|forgot-password|verify-email)(\/|$)/

const shellApp = {
  ...appShellStyles,
  height: '100dvh',
  overflow: 'hidden',

  onCreate: (el, s) => {
    el.call?.('installAppShellSync', s)
    // The smbls default router mounts pages into a 'content' div that sits in
    // the grid's 1fr row. That div has display:flex with overflow:visible by
    // default — it expands beyond the grid cell and the shell clips it, making
    // pages unscrollable. overflow:auto + min-height:0 constrain content to
    // the grid cell so the user can scroll within it.
    if (typeof document !== 'undefined' && !document.getElementById('__shell-content-scroll')) {
      const s = document.createElement('style')
      s.id = '__shell-content-scroll'
      s.textContent = '[data-key="content"]{overflow:auto;min-height:0}'
      document.head.appendChild(s)
    }
    const resolveSdk = () => el.sdk || el.context?.methods?.sdk || null
    el._unsubShellAuth = subscribeAuthSession(
      s.root,
      () => loadPrivateData(s.root, resolveSdk()),
      (claims) => onWorkspaceChange(s.root, resolveSdk(), claims)
    )
  },
  onRemove: (el) => {
    el.call?.('uninstallAppShellSync')
    if (typeof el._unsubShellAuth === 'function') {
      try { el._unsubShellAuth() } catch (_) {}
    }
  },

  AppHeader: {
    hide: (el, s) => {
      const path = s.root?.currentPath
      return AUTH_PATHS.test(typeof path === 'string' ? path
        : (typeof window !== 'undefined' ? window.location.pathname : '/'))
    }
  },

  TranslationWatcher: {
    visibility: 'hidden',
    position: 'fixed',
    pointerEvents: 'none',
    width: '0',
    height: '0',
    overflow: 'hidden',
    fetch: {
      from: 'i18n.translations',
      method: 'subscribe',
      params: (el, s) => ({ lang: s.root?.lang || 'en', namespace: 'all' })
    }
  },

  // Full-viewport "Switching to <org>…" overlay. Mounted at shell scope
  // (not inside a sub-app) so it covers the entire UI during the JWT
  // refresh round-trip. Driven by `root._wsSwitching`.
  AppWorkspaceSwitchOverlay: {}
}

export default shellApp
